export const data = {
  hero: {
    heading: "Geography, Ticks and You",
    headingStyled: "You",
    anchors: [
      {
        id: "anchor-1",
        title: "What are tickborne diseases?",
      },
      {
        id: "anchor-2",
        title: "Why are they a public health problem?",
      },
      {
        id: "anchor-3",
        title: "Why does geography matter?",
      },
      {
        id: "anchor-4",
        title: "Forest Fragmentation",
      },
      {
        id: "anchor-5",
        title: "Climate Change",
      },
      {
        id: "anchor-6",
        title: "Where do we go from here?",
      },
    ],
    subheading:
      "Why does geography matter for tickborne diseases and why it’s so complicated?",
  },
  cta: {
    heading: "Explore More",
    body:
      "Use our interactive dashboard full of detailed information on Lyme disease in the United States and Canada",
    buttonText: "Go to Data Explorer",
  },
}
